import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';

import 'rxjs/add/observable/of';

import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import  {MchSolicitudNotasId,SolicitudNotasIndexModel} from './SolicitudNotas.model';


import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';


@Component({
	selector : 'SolicitudNotas',
	templateUrl : './SolicitudNotasIndex.component.html',
    styleUrls  : ['../../../../styles.css']
})


export class SolicitudNotasIndexComponent  {

    
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public registroEscritura;
	public guardando:boolean;
	public tercero:string;
	public displayedColumns;
	public dataSource;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public solicitudNotas:Array<SolicitudNotasIndexModel>;
    


	constructor(private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar, 
		private _route: ActivatedRoute, private _router:Router,private _location: Location,
		private confirmarEliminacionService:ConfirmarEliminacionService)
	{

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		
		this.solicitudNotas = new Array();
		this.displayedColumns = ['Negocio','Nombre del Negocio','Factura','Nro Escritura','Nota','Editar'];
		this.dataSource = new ExampleDataSource(null);
	}


	ngOnInit(){
		this.cargarInfo(this.registroEscritura);
		this.dataSource = new ExampleDataSource(this.solicitudNotas);
		
		
	}

	cargarInfo(registroEscritura){
		this.dataSource = new ExampleDataSource(null);	
		this.solicitudNotas = new Array();
		
		this._serviciosGenerales.get('listadoSolicitudNotas', {cusuario:this._serviciosGenerales.seguridad.getInfoSesion().usuario}).subscribe(result =>{
			for(let x of result){
                this.solicitudNotas.push(new SolicitudNotasIndexModel(new MchSolicitudNotasId(x.CID,x.VIDESCRITURA,x.CNUMCONT,x.CPREFIJO),x.NUMERO_FACTURA,x.NOTA,x.NOMBRE));                    
			};
			this.dataSource = new ExampleDataSource(this.solicitudNotas);
		}, 
		error =>{
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar las sucursales asociadas", "X");

		});
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	agregar(){
		this._router.navigate(['/SolicitudNotas',2]);	
	}

	consultar(registro){
		console.log(registro.id.cid)
		this._router.navigate(['/SolicitudNotas',registro.id.cid,3]);	
	
	}
	
	


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
}


export class ExampleDataSource {

	public data: Array<SolicitudNotasIndexModel>;

	constructor(solicitudNotas:Array<SolicitudNotasIndexModel>){
		this.data = new Array();
		
		if(solicitudNotas != null){
			for(let i of solicitudNotas){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<SolicitudNotasIndexModel[]>
	{
		return Observable.of(this.data);
	}
	disconnect()
	{
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/SolicitudNotas/SolicitudNotasIndex.component.ts